module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#thump",
      toString: function () {
        return this.url;
      }
    }